import { get } from '@kit/utils/APIV1.js'

export const aboutUs = async(id) => {
  const what = await get('about-us')
  return what
}
